/**
 * @Author: wangbaihe
 * @Date: 2024-09-19 14:14:12
 * @LastEditors: wangbaihe
 * @LastEditTime: 2024-12-05 10:12:58
 * @FilePath: \common-mediax\src\apis\MediaCloudMbd\track.js
 * @Description: 打包后对createAPI、requestCommonAPI方法中的url参数进行加密处理，如需在此文件中对url进行二次处理，请先调用decryptUrl解密
 */
import { createAPI, decryptUrl } from '@common'
import qs from 'qs'

/**
 * 对api请求进行二次封装，注意：因在打包后会对url进行加密处理在该方法内请勿直接操作url，如需操作可引用common中decryptUrl先进行解密再操作
 * @param url
 * @param action
 * @param config
 * @param vconfig
 * @returns {*}
 */
const requestCommonAPI = function (url, action, config = {}, vconfig) {
  const customPrefix = vconfig?.customPrefix || false
  // 对url进行解密
  url = decryptUrl(url)
  if (!customPrefix) {
    url = '/mediax-mbd' + url
  }
  config = {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...config.headers
    },
    closeErrorMsg: true
  }
  if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    config.data = qs.stringify(config.data)
  }
  return createAPI(url, action, config, vconfig)
}
export default {
  // 领域
  postCategory: (config) => requestCommonAPI('customEncryptApiName-1/0bqj0dbufhpsz', 'post', config),
  // 地域
  postRegions: (config) => requestCommonAPI('customEncryptApiName-1/0bqj0sfhjpot', 'post', config),
  //全文检索导出
  postMediaExport: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0rvfsz0nfejb0fyqpsu', 'post', config, {
      timeout: 300000
    }),
  //查询App操作授权树
  postModuleOpModules: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nce.sftpvsdf.bddftt0npevmfPq0npevmft', 'post', config),
  //保存操作授权
  postModuleOpSave: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nce.sftpvsdf.bddftt0npevmfPq0tbwf', 'post', config),
  //查询Module操作授权按钮
  postModuleOpOperations: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nce.sftpvsdf.bddftt0npevmfPq0pqfsbujpot',
      'post',
      config
    ),
  //查询流程记录
  postDocumentRecords: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0epdvnfou0pqfsbujpot0sfdpset', 'get', config),
  // 媒体机构所属省市
  postMediaRegion: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0nfejb0sfhjpo', 'post', config, {
      neverLoading: true
    }),
  //用户榜单列表数据
  postRanklistUserList: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nce.dmpve.iputqpu0sbolmjtu0vtfs0mjtu', 'post', config, {
      neverLoading: true
    }),
  //榜单列表数据
  postRanklistList: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nce.dmpve.iputqpu0sbolmjtu0mjtu', 'post', config, {
      neverLoading: true
    }),
  // 全文检索
  postQueryMedia: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0rvfsz0nfejb', 'post', config),
  ftsDocument: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0gut0epdvnfou', 'post', config, {}),
  yqFtsDocument: (config) => requestCommonAPI('customEncryptApiName-1/0epdvnfou', 'post', config, {}),
  postMyinfo: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0nzjogp', 'post', config, {
      neverLoading: true
    }),
  //获取稿件关键词
  postContentKeyword: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0lfzxpse', 'post', config, {
      customPrefix: true
    }),
  //获取获取稿件背景
  postContentEntityRecogLink: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0foujuzSfdphMjol', 'post', config, {
      customPrefix: true
    }),
  // 精选推荐-列表导出
  querySubscribeExport: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0tvctdsjcf0dpmvno0rvfsz0fyqpsu', 'post', config, {
      timeout: 300000
    }),
  // 获取跳转到大数据跳转链接
  getMbdInfluenceOverview: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0sfejsfdu0vsm0nfejby.jogmvfodf.pwfswjfx',
      'post',
      config
    ),
  // 获取首页大数据传播KPI数据（点赞分享等）
  getMbdSourceKpi: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nce.tqsfbe0usbotnjttjpo0tpvsdf0lqj', 'post', config),
  // 获取首页大数据账号KPI数据（粉丝数等）
  getMbdAccountKpi: (config) =>
    requestCommonAPI('customEncryptApiName-1/0cfibwjps.bqj0tpvsdf0bddpvou', 'post', config),
  // 获取当前登录账号所管理的媒体账号
  getUserAccount: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.benjo0vtfst0cspxtjoh0bddpvout', 'get', config, {
      customPrefix: true
    }),
  // 获取跳转到大数据-属地动态跳转链接
  getMbdTrackLocal: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0sfejsfdu0vsm0nfejby.usbdl.mpdbm', 'post', config),
  // 获取跳转到大数据-AI传播力简报跳转链接
  getMbdInfluenceReport: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0sfejsfdu0vsm0nfejby.jogmvfodf.sfqpsu',
      'post',
      config
    )
}
